module.exports = __webpack_public_path__ + "static/img/rails.e4b772f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rails.png
// module id = 6kZB
// module chunks = 0